import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCall";

// Multi-format logo fetch (webp -> png fallback) mirroring product image behaviour.
export const useLogoImage = (
  companyContactNo,
  enabled = true,
  options = {},
) => {
  const {
    preferredFormats = ["webp", "png"],
    extension, // force single extension if required
  } = options;

  const normalised = (companyContactNo || "").replace(
    /\.(webp|png|avif|jpe?g)$/i,
    "",
  );
  const formatsToTry = extension ? [extension] : preferredFormats;
  const acceptHeader =
    formatsToTry
      .map((f) =>
        f === "png" ? "image/png" : f === "webp" ? "image/webp" : `image/${f}`,
      )
      .join(",") + ",*/*";

  return useQuery({
    queryKey: ["logoImage", normalised, formatsToTry.join("|")],
    enabled: enabled && !!normalised,
    queryFn: async () => {
      for (const ext of formatsToTry) {
        const path = `logo-images/${normalised}.${ext}`;
        try {
          const response = await callApi({
            method: "get",
            url: path,
            responseType: "blob",
            headers: { Accept: acceptHeader },
          });
          if (response?.data instanceof Blob && response.data.size > 0) {
            return response.data;
          }
        } catch (e) {
          continue; // try next format
        }
      }
      throw new Error(`No available logo image formats for ${normalised}`);
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
